export default ({ alertTip }) => <>
  <div className="projecttarget" id="projecttarget1">
    <h2 className="cs-title_title title_titlef" >
      <div className="min-titlef-blue"></div>
      01. Overview of Carbon Credit Project Registration
    </h2>
    <div className="cs-bid_info">
      A carbon credit project aims to issue carbon credits through activities that reduce or remove greenhouse gas (GHG) emissions. These projects help organizations achieve sustainability goals, contribute to environmental protection, and generate economic value through participation in the carbon market.
    </div>
  </div>
  <div className="projecttarget" id="projecttarget2">
    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      02. Project Registration Process
    </h2>
    <div className="cs-bid_info">
      <div>Project registration follows these steps.</div>
      <div className="min-titlef">01 Project Registration Request</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>How to Register</label> : Click the [Project Registration Request] button on the platform to begin your application.</li>
          <li><label>Email Submission</label> : After submitting the request, an application form (PDF or Word) will be automatically sent to your registered email address.</li>
          <li><label>Form Completion</label> : Complete the form with the required project details and return it to the specified email address.</li>
          <li><label>Submission Confirmation</label> : Upon submission, a confirmation email will be sent, and the project status will be marked as “Under Review.”</li>
        </ul>
      </div>
      <div className="min-titlef">02 Project Document Submission</div>
      <div style={{ fontSize: "18px", marginBottom: "20px" }}>Applicants must submit documentation for project evaluation. Required contents include.</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>Project Overview</label> : Project name, location, implementing organization and contact info, project type (e.g., DAC, EW), methodology (applied/newly developed/revision of existing).</li>
          <li><label>Carbon Reduction Plan and Projections</label> : Baseline, estimated annual GHG reductions, mitigation mechanisms and technologies.</li>
          <li><label>Project Timeline</label> : Expected start and end dates, milestones.</li>
          <li><label>Financial & Investment Plan</label> : Budget, funding plans.</li>
          <li><label>Legal and Environmental Assessment</label> : Environmental impact report, stakeholder engagement.</li>
          <li><label>Other Required Documents</label> : Additional materials per certification body guidelines or third-party feasibility reports. Documents must be in PDF or Word format. File size limits may apply.</li>
        </ul>
      </div>
      <div className="min-titlef">03 Review and Approval Procedure</div>
      <div style={{ fontSize: "18px", marginBottom: "20px" }}>Upon submission, the review team proceeds with the following.</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>Methodology Review (up to 15 business days)</label> : Assess whether existing approved methodologies apply. If not, the applicant may revise using approved methodologies or submit a new one.</li>
          <li><label>Initial Document Review (up to 10 business days)</label> : Check for completeness; missing items will trigger a supplement request via email.</li>
          <li><label>Technical Review (up to 30 business days)</label> : Evaluate feasibility, expected reductions, legal compliance, and environmental impacts. May require interviews or additional documentation.</li>
          <li><label>Final Approval or Rejection (up to 15 business days)</label> : Decision is made and communicated. Approved projects proceed to the advance credit issuance phase. Rejected projects receive feedback and may request reconsideration.</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="projecttarget" id="projecttarget3">
    <h2 className="cs-title_title title_titlef" >
      <div className="min-titlef-blue"></div>
      03. Review Outcome & Follow-up
    </h2>
    <div className="cs-bid_info">
      <div>The result of the project review will be sent to the applicant’s email.</div>
      <div className="min-titlef">01 If Approved</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>Official Project Registration</label> : Project is listed on the platform, and a summary is publicly available six months post-registration.</li>
          <li><label>Advance Carbon Credit Issuance</label> : Project owner proceeds with credit issuance and trading procedures.</li>
          <li><label>Project Progress Evaluation</label> : The project will be periodically monitored against submitted plans. Failure to execute the plan may result in cancellation and credit forfeiture.</li>
          <li><label>Final Credit Issuance</label> : Verified emission reductions through monitoring reports result in full credit issuance.</li>
        </ul>
      </div>
      <div className="min-titlef">02 If Rejected</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>Reason Notification</label> : Rejection details are provided via email.</li>
          <li><label>Resubmission</label> : Rejected projects can revise and resubmit based on feedback.</li>
          <li><label>*How to Request a Re-evaluation</label> :
            <div>
              Review the reason for rejection. Prepare the requested additional documents.<br />
              Resubmit the revised documents.<br />
              The foundation will review the updated documents and determine final approval.<br />
            </div>
          </li>
        </ul>
      </div>
      <div className="min-titlef">03 Procedure for Registering a New Methodology</div>
      <div style={{ fontSize: "18px", marginBottom: "20px" }}>If an existing methodology cannot be applied, you must go through the process of registering a new one.</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>Review of Existing Methodologies</label> : Assess whether a new methodology can be developed by adapting an existing one to the project.</li>
          <li><label>New Methodology Registration</label> : Follow a separate process for registering a new methodology.</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="projecttarget" id="projecttarget4">
    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      04. New Methodology Submission
    </h2>
    <div className="cs-bid_info">
      <div>Even after a project is approved, additional requests may be made for specific reasons.</div>
      <div className="min-titlef">01 Project Information Update Request</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>Update Request</label> : If certain information (e.g., change of project manager, project schedule adjustment, etc.) needs to be updated after project registration, you can submit a request through the project management page.</li>
          <li><label>Review and Approval</label> : Once the update request is submitted, it will be reviewed, and approval will be determined accordingly.</li>
        </ul>
      </div>
      <div className="min-titlef">02 Submit Additional Documents</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>Additional Document Upload</label> : If additional documents are required during the carbon credit certification process, you can request to upload them through the platform.</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="projecttarget" id="projecttarget5">
    <h2 className="cs-title_title title_titlef" >
      <div className="min-titlef-blue"></div>
      05. Important Notes During Project Implementation
    </h2>
    <div className="cs-bid_info">
      <div>Project registrants must be fully aware of the following points.</div>
      <div className="min-titlef">01 Data Submission</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>Monitoring Compliance</label> : All data must comply with the monitoring procedures outlined in the methodology.</li>
          <li><label>Methodology Updates</label> : Even for already approved projects, any updates to the applied methodology must be reflected in the project accordingly.</li>
          <li><label>Ensuring Reliability</label> : All methodologies and projects require third-party data verification. If procedures are not followed or false data is submitted, the foundation reserves the right to revoke project approval.</li>
        </ul>
      </div>
      <div className="min-titlef">02 Compliance with Document Format</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>Format and Standards Compliance</label> : Required formats (e.g., PDF, Word) and standard templates must be strictly followed.</li>
        </ul>
      </div>
      <div className="min-titlef">03 Responding to Revision Requests Upon Rejection</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>Responding to Revision Requests</label> : During the review process, you may receive requests for revisions. Failure to respond may result in the cancellation of your project registration.</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="projecttarget" id="projecttarget6">
    <h2 className="cs-title_title title_titlef">
      <div className="min-titlef-blue"></div>
      06. Customer Support
    </h2>
    <div className="cs-bid_info" style={{ paddingBottom: "200px" }}>
      <div style={{ marginBottom: "20px" }}>If you have any questions during the project registration or review process, or if you need technical support, you can contact us through the following methods.</div>
      <div className="agreement-panel">
        <ul style={{ marginBottom: 0 }}>
          <li><label>Email Inquiry</label> : help@capcotwo.com</li>
        </ul>
      </div>
      <div style={{ fontSize: "15px" }}>
        <label style={{ fontWeight: "bold" }}>* Attachment Description</label> | Required Documents for Carbon Credit Project Registration. Document Submission Guidelines<br />
        All documents must be submitted in PDF or Word format.<br />
        The content must be based on accurate and objective data.<br />
        If the Climate Foundation provides a required template, it must be used.<br />
        Each file must be under 10MB. If additional materials need to be submitted, they may be compressed into a ZIP file.<br />
      </div>
      <button className="cs-btn cs-style1" style={{ borderRadius: "10px", float: "right", marginTop: "20px" }} onClick={alertTip}><span style={{ position: "relative" }}>Project Registration Application</span></button>
    </div>
  </div>
</>
